import { dateUtility } from "../../service/date_utility"
import * as MutationTypes from "../mutation_types"
import { State } from "../store_types"

const getDefaultState  = () => {
  const today = new Date
  const prevMonth = dateUtility().prevMonth()
  const selectedYearlySummaryStartDate = new Date(dateUtility().fiscalYear(), 3, 1) // 前月が含まれる年度の最初の月(4月）
  const selectedYearlySummaryEndDate = prevMonth // 前月
  return {
    selectedCorporationId : null,
    selectedHomeDate : today, // ホーム画面
    selectedYearlySummaryStartDate: selectedYearlySummaryStartDate, // 登録・利用数推移 From
    selectedYearlySummaryEndDate: selectedYearlySummaryEndDate, // 登録・利用数推移 To
    selectedComplaintsDate : prevMonth, // 主訴一覧
    selectedQuestionnaireDate: prevMonth, // アンケートフリー回答一覧
    selectedQuestionnaireAnalyticsDate: prevMonth, // アンケート集計
    selectedCasesearchQueryLogDate: prevMonth, // 検索ワードランキング
    selectedMedicineQuestionAnalyticsDate: prevMonth, // くすりぼ 利用・アンケート集計
    selectedMedicalInformationDate : prevMonth, // 医療情報 配信履歴一覧
    selectedMonthlyReportMailDate : prevMonth, // メール送信
  }
}
const selectedValues = {
  state: () => getDefaultState(),

  getters: {
    selectedCorporationId (state : State) {
      return state.selectedCorporationId
    },
    selectedHomeDate (state : State) {
      return state.selectedHomeDate
    },
    selectedMedicalInformationDate (state : State) {
      return state.selectedMedicalInformationDate
    },
    selectedMonthlyReportMailDate (state : State) {
      return state.selectedMonthlyReportMailDate
    },
    selectedComplaintsDate (state : State) {
      return state.selectedComplaintsDate
    },
    selectedQuestionnaireDate (state : State) {
      return state.selectedQuestionnaireDate
    },
    selectedQuestionnaireAnalyticsDate (state : State) {
      return state.selectedQuestionnaireAnalyticsDate
    },
    selectedMedicineQuestionAnalyticsDate (state : State) {
      return state.selectedMedicineQuestionAnalyticsDate
    },
    selectedYearlySummaryStartDate (state : State) {
      return state.selectedYearlySummaryStartDate
    },
    selectedYearlySummaryEndDate (state : State) {
      return state.selectedYearlySummaryEndDate
    },
    selectedCasesearchQueryLogDate(state: State) {
      return state.selectedCasesearchQueryLogDate
    },
  },

  actions: {
    async commitSelectedCorporationId({ dispatch, commit }: { dispatch: (actionName: string) => Promise<unknown>, commit: (mutationType:string, selectedCorporationId: number) => void }, selectedCorporationId: number){
      commit(MutationTypes.ASSIGN_SELECTED_CORPORATION_ID, selectedCorporationId)
      if(selectedCorporationId !== null ) {
        // 企業を切り替えたときに取得すべき情報を再取得
        await Promise.all([
          dispatch("fetchCorporation"),
          dispatch("fetchTotalRegistrationCounts"),
          dispatch("fetchRegistrationCounts"),
          dispatch("fetchUsageCounts"),
          dispatch("fetchCasesearchViewLogsCount"),
          dispatch("fetchMonthlyReportMail"),
          dispatch("fetchMonthlyMailRecipients"),
          dispatch("fetchComplaints"),
          dispatch("fetchAfterUseQuestionnaires"),
          dispatch("fetchComplaintPublicAvailability"),
          dispatch("fetchAfterUseQuestionnairePublicAvailability"),
          dispatch("fetchAnytimeConsultationCount"),
          dispatch("fetchNightConsultationCount"),
          dispatch("fetchDaytimeAdviceCount"),
          dispatch("fetchMedicineQuestionAnalytics"),
          dispatch("fetchCasesearchQueryLogs"),
        ])
      }
    },
    commitSelectedHomeDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedHomeDate: Date) => void }, selectedHomeDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_HOME_DATE, selectedHomeDate)
      // ホーム画面の対象月を切り替えたときに取得すべき情報を再取得
      dispatch("fetchRegistrationCounts")
      dispatch("fetchUsageCounts")
      dispatch("fetchCasesearchViewLogsCount")
    },
    commitSelectedMedicalInformationDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedMedicalInformationDate: Date) => void }, selectedMedicalInformationDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_MEDICAL_INFORMATION_DATE, selectedMedicalInformationDate)
      dispatch("fetchMedicalInformations")
    },
    commitSelectedMonthlyReportMailDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedMonthlyReportMailDate: Date) => void }, selectedMonthlyReportMailDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_MONTHLY_REPORT_MAIL_DATE, selectedMonthlyReportMailDate)
      dispatch("fetchMonthlyReportMail")
    },
    commitSelectedComplaintsDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedComplaintsDate: Date) => void }, selectedComplaintsDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_COMPLAINTS_DATE, selectedComplaintsDate)
      dispatch("fetchComplaints")
      dispatch("fetchComplaintPublicAvailability")
    },
    commitSelectedQuestionnaireDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedQuestionnaireDate: Date) => void }, selectedQuestionnaireDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_QUESTIONNAIRE_DATE, selectedQuestionnaireDate)
      dispatch("fetchAfterUseQuestionnaires")
      dispatch("fetchAfterUseQuestionnairePublicAvailability")
    },
    commitSelectedQuestionnaireAnalyticsDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedQuestionnaireAnalyticsDate: Date) => void }, selectedQuestionnaireAnalyticsDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_QUESTIONNAIRE_ANALYTICS_DATE, selectedQuestionnaireAnalyticsDate)
      dispatch("fetchAnytimeConsultationCount")
      dispatch("fetchNightConsultationCount")
      dispatch("fetchDaytimeAdviceCount")
    },
    commitSelectedMedicineQuestionAnalyticsDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, selectedMedicineQuestionAnalyticsDate: Date) => void }, selectedMedicineQuestionAnalyticsDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_MEDICINE_QUESTION_ANALYTICS_DATE, selectedMedicineQuestionAnalyticsDate)
      dispatch("fetchMedicineQuestionAnalytics")
    },
    commitSelectedYearlySummaryStartDate({ commit }: { commit: (mutationType:string, selectedYearlySummaryStartDate: Date) => void }, selectedYearlySummaryStartDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_YEARLY_SUMMARY_START_DATE, selectedYearlySummaryStartDate)
    },
    commitSelectedYearlySummaryEndDate({ commit }: { commit: (mutationType:string, selectedYearlySummaryEndDate: Date) => void }, selectedYearlySummaryEndDate: Date){
      commit(MutationTypes.ASSIGN_SELECTED_YEARLY_SUMMARY_END_DATE, selectedYearlySummaryEndDate)
    },
    resetSelectedValuesState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_SELECTED_VALUES_STATE)
    },
    commitSelectedCasesearchQueryLogDate({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType: string, selectedCasesearchQueryLogDate: Date) => void }, selectedCasesearchQueryLogDate: Date) {
      commit(MutationTypes.ASSIGN_SELECTED_CASESEARCH_QUERY_LOG_DATE, selectedCasesearchQueryLogDate)
      dispatch("fetchCasesearchQueryLogs")
    },
  },
  mutations: {
    [MutationTypes.ASSIGN_SELECTED_CORPORATION_ID](state: State, selectedCorporationId: number) {
      state.selectedCorporationId = selectedCorporationId
    },
    [MutationTypes.ASSIGN_SELECTED_HOME_DATE](state: State, selectedHomeDate: Date) {
      state.selectedHomeDate = selectedHomeDate
    },
    [MutationTypes.ASSIGN_SELECTED_YEARLY_SUMMARY_START_DATE](state: State, selectedYearlySummaryStartDate: Date) {
      state.selectedYearlySummaryStartDate = selectedYearlySummaryStartDate
    },
    [MutationTypes.ASSIGN_SELECTED_YEARLY_SUMMARY_END_DATE](state: State, selectedYearlySummaryEndDate: Date) {
      state.selectedYearlySummaryEndDate = selectedYearlySummaryEndDate
    },
    [MutationTypes.ASSIGN_SELECTED_MEDICAL_INFORMATION_DATE](state: State, selectedMedicalInformationDate: Date) {
      state.selectedMedicalInformationDate = selectedMedicalInformationDate
    },
    [MutationTypes.ASSIGN_SELECTED_MONTHLY_REPORT_MAIL_DATE](state: State, selectedMonthlyReportMailDate: Date) {
      state.selectedMonthlyReportMailDate = selectedMonthlyReportMailDate
    },
    [MutationTypes.ASSIGN_SELECTED_COMPLAINTS_DATE](state: State, selectedComplaintsDate: Date) {
      state.selectedComplaintsDate = selectedComplaintsDate
    },
    [MutationTypes.ASSIGN_SELECTED_QUESTIONNAIRE_DATE](state: State, selectedQuestionnaireDate: Date) {
      state.selectedQuestionnaireDate = selectedQuestionnaireDate
    },
    [MutationTypes.ASSIGN_SELECTED_QUESTIONNAIRE_ANALYTICS_DATE](state: State, selectedQuestionnaireAnalyticsDate: Date) {
      state.selectedQuestionnaireAnalyticsDate = selectedQuestionnaireAnalyticsDate
    },
    [MutationTypes.ASSIGN_SELECTED_MEDICINE_QUESTION_ANALYTICS_DATE](state: State, selectedMedicineQuestionAnalyticsDate: Date) {
      state.selectedMedicineQuestionAnalyticsDate = selectedMedicineQuestionAnalyticsDate
    },
    [MutationTypes.RESET_SELECTED_VALUES_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
    [MutationTypes.ASSIGN_SELECTED_CASESEARCH_QUERY_LOG_DATE](state: State, selectedCasesearchQueryLogDate: Date) {
      state.selectedCasesearchQueryLogDate = selectedCasesearchQueryLogDate
    },
  },
}

export default selectedValues
